/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ExperienceConstraintSchemaMode } from './experienceConstraintSchemaMode';

/**
 * Sub-doc-bound experience constraint. Every populated field must
 * match within the *same* `experiences` sub-doc, so this expresses
 * things like "engineering manager at Stripe during series_b" that the
 * flat filters can't (those AND at the parent doc level).
 */
export interface ExperienceConstraintSchema {
  company_name?: string | null;
  company_domain?: string | null;
  title?: string | null;
  title_levels?: string[] | null;
  title_roles?: string[] | null;
  funding_stages?: string[] | null;
  industry?: string | null;
  investors?: string[] | null;
  is_current?: boolean | null;
  start_date_gte?: string | null;
  start_date_lte?: string | null;
  end_date_gte?: string | null;
  end_date_lte?: string | null;
  mode?: ExperienceConstraintSchemaMode;
}
